package com.dotdrives.web.pages.settings

import kotlinx.browser.document
import kotlinx.browser.window
import react.useEffect
import react.useRef

/** Resolve the destination after dialog cleanup removes inertness and restores its old opener. */
fun useSettingsOutcomeFocus(open: Boolean, feedback: String?, feedbackId: String, openerId: String?) {
    val wasOpen = useRef(false)
    val announced = useRef(feedback)
    val returnTarget = useRef<String>(null)
    useEffect(open, feedback) {
        if (open) {
            if (wasOpen.current != true) returnTarget.current = openerId
            wasOpen.current = true
        } else {
            val saved = feedback != null && feedback != announced.current
            val target = if (saved) feedbackId else if (wasOpen.current == true) returnTarget.current else null
            wasOpen.current = false
            announced.current = feedback
            if (target != null) {
                // DialogFocus restores its captured node in a timer; this second turn gives
                // the confirmed outcome priority and also works when that node was removed.
                window.setTimeout({ window.setTimeout({
                    val element = document.getElementById(target)
                    if (element?.isConnected == true && element.closest("[inert]") == null) element.asDynamic().focus()
                }, 0) }, 0)
            }
        }
    }
}
